import { SummaryBlock, SummaryBlockItem } from '@api';
import { IDragData, SessionSummaryDragDataKey } from '@components';
import React, { useCallback, useState } from 'react';
import './summary-item-drop-comp.scss';


interface SummaryItemDropCompProps {
	onSummaryItemDrop: (summaryItem: SummaryBlockItem, summaryItemIndex: number, agendaItemId: string) => void,
	onSummaryItemReorderDrop: (oldBlock: SummaryBlock, oldIdex: number, newIndex: number, oldAgendaItemId: string, newAgendaItemId: string) => void,
	newIndex: number,
	agendaItemId: string,
	summaryBlock: SummaryBlock,
	canEdit: boolean,
}

function SummaryItemDropComp(props: SummaryItemDropCompProps): JSX.Element {
	const {
		onSummaryItemDrop,
		onSummaryItemReorderDrop,
		newIndex,
		summaryBlock,
		canEdit,
		agendaItemId,
	} = props;

	const 
		[isOver, setIsOver] = useState(false),
		// [overText, setOverText] = useState(''),
		[dragOverTarget, setDragOverTarget] = useState(null);

	const onDragEnter = (ev) => {
		if (!canEdit) {
			return;
		}
		const jsonText = sessionStorage.getItem(SessionSummaryDragDataKey);
		if (jsonText) {
			const data = JSON.parse(jsonText) as IDragData;
			if (data && data.source == 'transcript') {
				setDragOverTarget(ev.target);
				ev.preventDefault();
				ev.dataTransfer.dropEffect = "copy";

				// setOverText(data.text);
				setIsOver(true);
			}

			if (data && data.source == 'summary') {
				
				// Sync onDragOver and onDragEnter
				if (data.summaryBlock.blockName == summaryBlock.blockName 
					&& data.summaryItem.agendaItemId == agendaItemId
					&& (newIndex == data.summaryItemIndex || newIndex == data.summaryItemIndex + 1 )
				) {
					return;
				}

				ev.preventDefault();
				setDragOverTarget(ev.target);
				ev.dataTransfer.dropEffect = "move";
				// setOverText(data.summaryItem.text);
				setIsOver(true);
			}
		}
	}

	const onDragOver = (ev) => {
		if (!canEdit) {
			return;
		}
		const jsonText = sessionStorage.getItem(SessionSummaryDragDataKey);
		if (jsonText) {
			const data = JSON.parse(jsonText) as IDragData;
			if (data && data.source == 'summary') {
				
				// Sync onDragOver and onDragEnter
				if (data.summaryBlock.blockName == summaryBlock.blockName 
					&& data.summaryItem.agendaItemId == agendaItemId
					&& (newIndex == data.summaryItemIndex || newIndex == data.summaryItemIndex + 1 )
				) {
					return;
				}

				ev.preventDefault();
			} else {
				ev.preventDefault();
			}
		}
	}

	const onDragLeave = (ev) => {
		if (!canEdit) {
			return;
		}

		if (ev.target != dragOverTarget) {
			return;
		}
		setIsOver(false);
		// setOverText('');
		setDragOverTarget(null);
	}

	const onDrop = useCallback((ev) => {
		if (!canEdit) {
			return;
		}
		
		ev.preventDefault();
		setIsOver(false);
		// setOverText('');
		setDragOverTarget(null);

		const jsonText = sessionStorage.getItem(SessionSummaryDragDataKey);
		if (jsonText) {
			const data = JSON.parse(jsonText) as IDragData;
			if (data && data.source == 'transcript') {
				const newItem = new SummaryBlockItem({ text: data.text });
				onSummaryItemDrop(newItem, newIndex, agendaItemId);
			}

			if (data && data.source == 'summary') {
				onSummaryItemReorderDrop(data.summaryBlock, data.summaryItemIndex, newIndex, data.summaryItem.agendaItemId, agendaItemId);
			}
		}

		sessionStorage.setItem(SessionSummaryDragDataKey, null);


	}, [onSummaryItemDrop, onSummaryItemReorderDrop, newIndex, canEdit, agendaItemId]);

	let classNames = "summary-item-dropblock"; 
	if (isOver) {
		classNames += " summary-item-dropblock_over";
	}

	return (<div
			className={classNames}
			onDragEnter={onDragEnter}
			onDragLeave={onDragLeave}
			onDrop={onDrop}
			onDragOver={onDragOver}
			>
			<div className="summary-item-dropblock__content"></div>
		</div>);
}

const MemoisedSummaryItemDropComp = React.memo(SummaryItemDropComp);

export {MemoisedSummaryItemDropComp as SummaryItemDropComp};